import React, { FC, ForwardedRef, forwardRef } from 'react';
import { DateTimePickerTabsProps, usePickerTranslations, usePickerContext } from '@mui/x-date-pickers';
import { Tabs, Tab, Box } from '@mui/material';

/**
 * Customization of tabs in Date/Time pickers
 *  Taken from original code:
 *  https://github.com/mui/mui-x/blob/master/packages/x-date-pickers/src/DateTimePicker/DateTimePickerTabs.tsx
 */
export const FlowDateTimePickerTabs: FC<DateTimePickerTabsProps> = forwardRef(({ hidden, className }, ref) => {
  const translations = usePickerTranslations();
  const { view, setView } = usePickerContext();

  if (hidden) {
    return null;
  }

  return (
    <Box sx={{ px: 2 }}>
      <Tabs
        ref={ref as ForwardedRef<HTMLDivElement>}
        value={view === 'hours' ? 'hours' : 'day'}
        template="underlined"
        variant="fullWidth"
        onChange={(_, newView) => setView(newView)}
        className={className}
      >
        <Tab value="day" label={translations.dateTableLabel} />
        <Tab value="hours" label={translations.timeTableLabel} />
      </Tabs>
    </Box>
  );
});
